<div class="dynamic-form-container" [attr.dir]="getDir()">
  <!-- Error messages -->
  @if (apiErrors.length > 0) {
    <div class="alert alert-danger">
      @for (err of apiErrors; track $index) {
        <div>{{ err }}</div>
      }
    </div>
  }

  <!-- Success message -->
  @if (successMessage) {
    <div class="alert alert-success">{{ successMessage }}</div>
  }

  <!-- Library form component -->
  <fb-bs-generic-formly-form
    [formDefinition]="formDefinition"
    [formData]="model"
    [requestTypeLogicalId]="requestTypeLogicalId"
    [requestId]="requestId ?? undefined"
    (formSubmit)="onFormSubmit($event)">
  </fb-bs-generic-formly-form>

  <!-- Form Actions -->
  @if (!isLoading && formDefinition) {
    <div class="form-content">
      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="cancel()"
          [disabled]="isSubmitting || isSavingDraft || isUpdatingDraft || isUpdatingAndSubmitting">
          {{ 'common.cancel' | translate }}
        </button>

        <!-- SCENARIO 1: Creating New Request (not a draft) -->
        @if (!isDraftMode) {
          <button
            type="button"
            class="btn btn-secondary"
            (click)="saveDraft()"
            [disabled]="isSubmitting || isSavingDraft">
            @if (!isSavingDraft) {
              <span>
                <i class="bi bi-file-earmark-text me-2"></i>
                {{ 'requests.saveDraft' | translate }}
              </span>
            }
            @if (isSavingDraft) {
              <span>
                <i class="bi bi-hourglass-split me-2"></i>
                {{ 'common.processing' | translate }}
              </span>
            }
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="submitForm()"
            [disabled]="isSubmitting || isSavingDraft">
            @if (!isSubmitting) {
              <span>{{ 'common.submit' | translate }}</span>
            }
            @if (isSubmitting) {
              <span>
                <i class="bi bi-hourglass-split me-2"></i>
                {{ 'common.submitting' | translate }}
              </span>
            }
          </button>
        }

        <!-- SCENARIO 2: Editing Existing Draft -->
        @if (isDraftMode) {
          <button
            type="button"
            class="btn btn-secondary"
            (click)="updateDraft()"
            [disabled]="isUpdatingDraft || isUpdatingAndSubmitting || isSubmitting">
            @if (!isUpdatingDraft) {
              <span>
                <i class="bi bi-cloud-arrow-up me-2"></i>
                {{ 'requests.updateDraft' | translate }}
              </span>
            }
            @if (isUpdatingDraft) {
              <span>
                <i class="bi bi-hourglass-split me-2"></i>
                {{ 'common.processing' | translate }}
              </span>
            }
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="updateDraftAndSubmit()"
            [disabled]="isUpdatingAndSubmitting || isUpdatingDraft || isSubmitting">
            @if (!isUpdatingAndSubmitting) {
              <span>
                <i class="bi bi-send me-2"></i>
                {{ 'requests.updateAndSubmit' | translate }}
              </span>
            }
            @if (isUpdatingAndSubmitting) {
              <span>
                <i class="bi bi-hourglass-split me-2"></i>
                {{ 'common.submitting' | translate }}
              </span>
            }
          </button>
        }
      </div>
    </div>
  }
</div>
